import React, { Component } from 'react'
import FileIcon, { defaultStyles } from 'react-file-icon'

import { Get } from 'react-lodash'

// helper
const getExtennsion = filename => {
    let ans = ''

    for (let index = filename.length - 1; index >= 0; index--) {
        if (filename[index] === '.') break
        ans = filename[index] + ans
    }

    return ans
}

// get icon for extension
const getIcon = name => {
    const extension = getExtennsion(name)

    const props = 
        <Get object={defaultStyles} path={extension}>
        {
            value => <FileIcon extension={extension} {...value}/>
        }
        </Get>

    return props
}

class FileIconComponent extends Component {
    render() {
        const { name } = this.props
        return (
            <div className="icon">
                {getIcon(name)}
            </div>
        )
    }
}

export default FileIconComponent
